import { useLazyQuery } from '@apollo/client';
import { READ_UNLOCK_CODE_AVAILABILITY } from 'graphql/queries/readUnlockCodeAvailability';
import React, { useCallback } from 'react';
import {
  Query,
  QueryReadUnlockCodeAvailabilityArgs,
} from 'types/generatedSchemaTypes';
import UnlockPmcBase from './UnlockPmcBase';
import { useUnlockPmc } from 'hooks/useUnlockPmc';

const UnlockPmcModalContent: React.FC = () => {
  const {
    t,
    pmcId,
    unlockCode,
    errorMessage,
    setErrorMessage,
    handleInputChange,
    handleCancel,
    handleSuccess,
  } = useUnlockPmc();

  const [checkUnlockCode, { loading }] = useLazyQuery<
    Query,
    QueryReadUnlockCodeAvailabilityArgs
  >(READ_UNLOCK_CODE_AVAILABILITY, {
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true,
    onCompleted: (data) => {
      if (data?.readUnlockCodeAvailability?.available && pmcId) {
        handleSuccess(true);
      } else {
        setErrorMessage(t('permit.unlockPMC.incorrect'));
      }
    },
    onError: (error) => {
      console.error('Error checking unlock code:', error);
      setErrorMessage(t('permit.unlockPMC.incorrect'));
    },
  });

  const handleUnlock = useCallback(async () => {
    setErrorMessage(null);

    if (!pmcId) {
      setErrorMessage(t('permit.unlockPMC.incorrect'));
      return;
    }

    await checkUnlockCode({
      variables: {
        input: {
          unlockCode,
          pmcId,
        },
      },
    });
  }, [pmcId, checkUnlockCode, unlockCode, t, setErrorMessage]);

  return (
    <UnlockPmcBase
      unlockCode={unlockCode}
      errorMessage={errorMessage}
      loading={loading}
      onUnlock={handleUnlock}
      onCancel={handleCancel}
      onInputChange={handleInputChange}
    />
  );
};

export default UnlockPmcModalContent;
